<script>
    export default {
        name: 'CloseOutlineIcon',
        props: {
            width: {
                type: [Number, String],
                required: false,
                default: 24,
            },
            height: {
                type: [Number, String],
                required: false,
                default: 24,
            },
        },
    };
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" class="fill-current">
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
            d="M13.89 8.7L12 10.59 10.11 8.7a.996.996 0 10-1.41 1.41L10.59 12 8.7 13.89a.996.996 0 101.41 1.41L12 13.41l1.89 1.89a.996.996 0 101.41-1.41L13.41 12l1.89-1.89a.996.996 0 000-1.41c-.39-.38-1.03-.38-1.41 0zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
</template>
